import { autoinject } from 'aurelia-framework';
import { HttpClient } from 'aurelia-fetch-client';
import { RedirectToRoute } from 'aurelia-router';

@autoinject
export class AuthorizationServiceStep {
    constructor(private http: HttpClient) {

        http.configure(config => {
            config
                .useStandardConfiguration();
        });

    }

    async run(navigationInstruction, next) {
        console.log('Navigation Instruction:', navigationInstruction);

        // Only the 'licensing-overview-satellite' route must be authorized with an authorization token
        if (navigationInstruction.config.name !== 'licensing-overview-satellite') {
            return next(); // Allow navigation without validation
        }

        console.log("Running in satellite mode, authorization required.");

        const params = this.deserialize(window.location.search.substring(1));
        const authToken = params["authtoken"] || null;

        if (authToken === null) {
            // Cancel current request and redirect to error
            return next.cancel(new RedirectToRoute("error", { errorMessage: "Authorization token is missing." }));
        }
        else {
            // Token provided, validate
            const authResult = await this.validateAuthorizationToken(authToken);
            if (authResult !== true) {
                // Cancel current request and redirect to error
                return next.cancel(new RedirectToRoute("error", { errorMessage: "Authorization token is invalid." }));
            }
        }

        console.log("Authorized");
        return next(); // Allow navigation if the token is valid or not required
    }

    // Validate authorization token
    public async validateAuthorizationToken(token: string): Promise<boolean> {
        let response = null;
        try {
            response = await this.http.fetch('api/authorizationtoken/validate', {
                method: 'POST',
                body: JSON.stringify(token),
                headers: { 'Content-Type': 'application/json' }
            });

            if (response.ok) {
                return true;
            } else {
                console.error('Authorization validation failed:', response.statusText);
                return false;
            }
        } catch (error) {

            if (response && response.status === 401) {
                console.log('Authorization token is invalid, not authorized to continue');
            }
            else {
                console.error('Error validating authorization token:', error);
            }

            return false;
        }
    }

    // This method is copied from home.ts -> add to shared class
    private deserialize(searchPath: string) {

        return String(searchPath)
            .split("&")
            .reduce((result, param) => {
                let [key, value] = param.replace('+', ' ').split('=', 2);

                result[key.toLowerCase()] = decodeURIComponent(value);

                return result;
            }, {});
    }
}



// WEBPACK FOOTER //
// ./ClientApp/app/services/authorization-service.ts